<script setup>
// Astra DS · ShareChip — el chip «Compartir» con su popover.
//
// Junta las dos piezas para que las vistas no tengan que cablear el estado, la
// posición y el cierre cada una por su cuenta: Home y Radio lo montan igual, y
// duplicarlo era la vía rápida a que se comportaran distinto.
//
// El chip es el ancla: el popover se posiciona contra él, así que el
// contenedor establece el contexto.
import { ref } from "vue";
import ChipAction from "./ChipAction.vue";
import SharePopover from "./SharePopover.vue";

defineProps({
  // Se pasa al chip: sobre una foto, el filete y la tinta son otros.
  surface: {
    type: String,
    default: "canvas",
    validator: (v) => ["canvas", "imagen"].includes(v),
  },
  label: { type: String, default: "Compartir" },
  url: { type: String, default: "" },
  text: { type: String, default: "" },
});

const abierto = ref(false);
</script>

<template>
  <span class="share-chip">
    <ChipAction
      :surface="surface"
      :label="label"
      as="button"
      :aria-expanded="abierto ? 'true' : 'false'"
      @click="abierto = !abierto"
    />
    <SharePopover
      v-if="abierto"
      :url="url"
      :text="text"
      @close="abierto = false"
    />
  </span>
</template>

<style scoped lang="scss">
// `inline-flex` y no `block`: el chip vive dentro de un chipset donde los
// vecinos comparten borde, y un contenedor de bloque rompería esa fila.
.share-chip {
  position: relative;
  display: inline-flex;
}
</style>
